import { Badge, Group, Stack, Title, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"

import { DisplaySettings } from "~/pages/Brand/OrganizationSettings/ProductPages/OutputCustomizationSettings/DisplaySettings.tsx"
import { ProductSheetComponents } from "~/pages/Brand/OrganizationSettings/ProductPages/ProductSheetComponents"
import { useOrganizationSettings } from "~/pages/Brand/OrganizationSettings/store/organization-settings-context"

interface Props {
  settings: OrganizationsResponses.Organization["settings"]
  isAdmin: boolean
}

export const OutputCustomizationSettings = ({ settings, isAdmin }: Props) => {
  const { t } = useTranslation("organizationSettings")
  const { organization, displaySettingsId } = useOrganizationSettings()
  return (
    <Stack>
      <Group>
        <Title order={3}>{t("outputs.title")}</Title>
        <Badge color="gray">
          {settings.outputCustomizationPlan == "ESSENTIAL" &&
            t(`outputs.essential`)}
          {settings.outputCustomizationPlan == "ADVANCED" &&
            t(`outputs.advanced`)}
          {settings.outputCustomizationPlan == "EXPERT" && t(`outputs.expert`)}
        </Badge>
        <Text c="gray" fz="sm">
          {t("contactSupport")}
        </Text>
      </Group>
      <Group>
        {settings.displaySettings.map((displaySetting) => (
          <DisplaySettings
            key={displaySetting.id}
            displaySetting={displaySetting}
            settings={settings}
          />
        ))}
      </Group>
      {isAdmin && displaySettingsId && (
        <ProductSheetComponents
          displaySettingsId={displaySettingsId}
          organizationId={organization.id}
        />
      )}
    </Stack>
  )
}
